import _ from 'lodash';

export default function getComingSoonPets(pets) {
	return _.filter(pets, 'isComingSoon');
}



// WEBPACK FOOTER //
// ./src/selectors/getComingSoonPets.js